import { StyledButton } from "./Button.styled";

export const Button = (props) => {
	return <StyledButton {...props} />;
};
